import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import type { IDocumentType } from "@/types/(company)/documentTypes.interface";
import { createApi } from "@reduxjs/toolkit/query/react";

interface DocumentTypesResponse {
  data: IDocumentType[];
  meta: { total: number; page: number; lastPage: number; limit: number };
}

interface DocumentTypesParams {
  limit?: number;
  page?: number;
  search?: string;
  category?: string;
}

export const companyDocumentTypesApi = createApi({
  reducerPath: "companyDocumentTypesApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["CompanyDocumentTypes"],
  endpoints: (builder) => ({
    getCompanyDocumentTypes: builder.query<DocumentTypesResponse, DocumentTypesParams | void>({
      query: (params) => ({
        url: "/company/document-types",
        params: { limit: 100, ...params },
      }),
      providesTags: ["CompanyDocumentTypes"],
    }),
    createCompanyDocumentType: builder.mutation<{ data: IDocumentType }, Partial<IDocumentType>>({
      query: (body) => ({ url: "/company/document-types", method: "POST", body }),
      invalidatesTags: ["CompanyDocumentTypes"],
    }),
    updateCompanyDocumentType: builder.mutation<{ data: IDocumentType }, { id: number; body: Partial<IDocumentType> }>({
      query: ({ id, body }) => ({ url: `/company/document-types/${id}`, method: "PUT", body }),
      invalidatesTags: ["CompanyDocumentTypes"],
    }),
    deleteCompanyDocumentType: builder.mutation<void, number>({
      query: (id) => ({ url: `/company/document-types/${id}`, method: "DELETE" }),
      invalidatesTags: ["CompanyDocumentTypes"],
    }),
    toggleCompanyDocumentTypeStatus: builder.mutation<{ data: IDocumentType }, number>({
      query: (id) => ({ url: `/company/document-types/${id}/toggle-status`, method: "PATCH" }),
      invalidatesTags: ["CompanyDocumentTypes"],
    }),
  }),
});

export const {
  useGetCompanyDocumentTypesQuery,
  useCreateCompanyDocumentTypeMutation,
  useUpdateCompanyDocumentTypeMutation,
  useDeleteCompanyDocumentTypeMutation,
  useToggleCompanyDocumentTypeStatusMutation,
} = companyDocumentTypesApi;
